<div class="remove-modal-dialog">
  <div class="modal-content p-4">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ 'modal.confirm_delete_user.title' | translate }}
      </h5>
      <button type="button" class="btn close btn-secondary" (click)="handleCloseClick()">
        <span>&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <ng-container *ngIf="!secondStep">
        {{ 'modal.confirm_delete_user.message' | translate }}
      </ng-container>

      <ng-container *ngIf="secondStep">
        {{ 'modal.confirm_delete_user.message_second' | translate }}
      </ng-container>
    </div>

    <div class="modal-footer pt-2 px-2 d-flex" [ngClass]="{ 'flex-row-reverse': secondStep }">
      <button class="btn btn-secondary mx-2" (click)="handleCloseClick()">
        {{ 'modal.default_cancel_button' | translate }}
      </button>

      <button class="btn btn-danger mx-2" (click)="handleDeleteClick()" [disabled]="!data">
        {{
          secondStep
            ? ('modal.confirm_delete_user.button_delete_confirm' | translate)
            : ('modal.confirm_delete_user.button_delete' | translate)
        }}
      </button>
    </div>
  </div>
</div>
